export const captureSentryException = (error: unknown) => {
  window.Sentry && window.Sentry.captureException(error);
};
